import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { LoginResponse, OidcSecurityService } from "angular-auth-oidc-client";
import { map, switchMap, Observable, of } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class AppAuthService {
  private _isAuthenticated: boolean = false;
  private _isAuthFlowStarted: boolean = false;

  private _postLoginUrlKey: string = 'careers_pl_url';


  constructor(private _http: HttpClient, @Inject('API_URL') private _apiUrl: string, private _oidcSecurityService: OidcSecurityService) { }

  public init(): void {
    //this._oidcSecurityService.con
  }

  public getUsername(): Observable<string> {
    return this._oidcSecurityService.getUserData().pipe(
      map(r => {
        return r['email'] || r['sub'] || r['name'] || '';
      })
    );
  }

  public getAccessToken(): Observable<string> {
    return this._oidcSecurityService.getAccessToken();
  }

  public isAuthenticated(): Observable<boolean> {
    if (this._isAuthenticated) {
      return of(true);
    }
    if (this._isAuthFlowStarted) {
      return this._oidcSecurityService.isAuthenticated();
    }

    // flow should be started only once, after that we should use isAuthenticated()
    this._isAuthFlowStarted = true;
    return this.startAuth().pipe(
      map(r => {
        return r && r.isAuthenticated;
      })
    );
  }

  // check if user is authenticated if yes return token and related token response
  public startAuth(): Observable<LoginResponse> {
    return this._oidcSecurityService.getRefreshToken().pipe(
      switchMap(refreshToken => {
        if (!refreshToken) {
          return this._oidcSecurityService.checkAuth();
        }
        else {
          return this._oidcSecurityService.checkAuthIncludingServer();
        }
      })
    );
  }

  /**
   * set the local app url to redirect the user to after finishing the login flow
   * @param href
   */
  public setPostLoginRedirectUrl(href: string): void {
    // store redirect url
    localStorage.setItem(this._postLoginUrlKey, href);
  }
  public getPostLoginRedirectUrl(): string | null {
    let url = localStorage.getItem(this._postLoginUrlKey);
    return url;
  }
  public clearPostLoginRedirectUrl(): void {
    localStorage.removeItem(this._postLoginUrlKey);
  }

  public continueLogin(): Observable<LoginResponse> {
    return this._oidcSecurityService.checkAuth();
  }

  /** challenge login to identity */
  public login(): void {
    this._oidcSecurityService.authorize();
  }

  // logout from system
  public logout(): Observable<unknown> {
    return this._oidcSecurityService.logoff();
  }
}
